import React from 'react';
import {IListConfigContext} from '../@interfaces/contexts/IListConfigContext';

export const ListConfigContext = React.createContext<IListConfigContext<any> | null>(null);
